import React from 'react';

import { LineChart } from '@/nova/components';
import { SparkWrap } from './dashboard.styles';

export interface SparklineProps {
  points: number[];
  color: string;
  /** The metric this sparkline plots; shown in the hover readout so the tooltip names the metric, not an internal series id. */
  name: string;
  /** Per-point date labels (`YYYY-MM-DD`) for the tooltip heading, one per point. */
  pointLabels?: string[];
}

/**
 * Tiny single-series trend line for a KPI tile (fed through MetricCard's `note`
 * slot). Renders nothing for fewer than two points, so a monthly/absent series
 * leaves the tile clean rather than drawing a dot. The hover readout shows the
 * metric name + the day's value.
 */
export const Sparkline = ({ points, color, name, pointLabels }: SparklineProps): React.ReactElement | null => {
  if (points.length < 2) return null;
  return (
    <SparkWrap>
      <LineChart series={[{ name, color, points }]} xLabels={[]} pointLabels={pointLabels} showY={false} height={28} area />
    </SparkWrap>
  );
};

export default Sparkline;
